---
ID: 66d8115989048aba1b50e5eb
---

<script>
    import Loader from "$lib/components/elements/Loader.svelte"

    const blocks = [
  {
    "id": "yvt-zopvfS",
    "type": "text",
    "html": "<p><b>Cards</b>&nbsp;are a versatile and visually appealing way to present information in your documentation. They allow you to organize content effectively and engage users with a well-structured layout.</p><h2 id=\"adding-cards\"><b>Adding Cards</b></h2><p>To add a card, simply select the menu that appears when you hover over or select any other block in your documentation. This intuitive interface makes it easy to incorporate cards into your layout, providing a smooth experience as you build your documentation.</p><h2 id=\"structure-of-a-card\"><b>Structure of a Card</b></h2><p>Each card consists of two main parts:</p><ul><li><b>Title</b>: A concise text title that clearly describes the content of the card. This title serves as a quick reference, helping users understand the purpose of the card at a glance.</li><li><b>Body</b>: The body of the card is fully formatable, allowing you to use all the text formatting features listed in the&nbsp;<b><u><a href=\"https://docs.easypagego.com/editor/text-formatting/\" target=\"_blank\" rel=\"noopener noreferrer\">Text Formatting</a></u></b>&nbsp;page. This flexibility enables you to include rich content such as lists, links, images, and more, making your cards both informative and engaging.</li></ul>"
  },
  {
    "id": "LQx3N3g1Db",
    "type": "card",
    "items": [
      {
        "id": "i_agk3yMHQ",
        "title": "Getting Started",
        "html": "<ul><li>Learn the basics of using EasyPageGO.</li><li>Step-by-step guide to creating your first page.</li><li>Realize how easy that is</li></ul>"
      }
    ]
  },
  {
    "id": "-GVAn57-UA",
    "type": "text",
    "html": "<h2 id=\"multiple-cards\"><b>Multiple Cards</b></h2><p>From the card's menu, you have the option to&nbsp;<b>\"Add Card\"</b>. This feature allows you to group multiple cards as needed.</p>"
  },
  {
    "id": "bUxpIWQCQ5",
    "type": "callout",
    "variant": "note",
    "html": "<p>In the case of an&nbsp;<i>odd number of cards</i>, the last card will automatically expand to fill the available space, creating a&nbsp;<b>visually balanced layout</b>. This feature enhances the overall aesthetics of your documentation and ensures that your content is presented in a clean and organized manner.</p>"
  },
  {
    "id": "jjTZdHS8Lq",
    "type": "card",
    "items": [
      {
        "id": "MyGZF-Mexk",
        "title": "You can use formatted text",
        "html": "<p>For example, why don't you add a link to some&nbsp;<u><a href=\"https://docs.easypagego.com/website-structure/computed-elements/\" target=\"_blank\" rel=\"noopener noreferrer\">other page</a></u>?</p>"
      },
      {
        "id": "Er9N7Q6OBo",
        "title": "Always fill the gap",
        "html": "<p>On larger screens, cards are shown in two columns. However, if the last one stands alone, it will fill both spaces.</p>"
      },
      {
        "id": "hWDuHu23uk",
        "title": "Features",
        "html": "<p>You can use cards to create visual appealing layouts.</p>"
      }
    ]
  }
];
</script>

{#each blocks as block}
<Loader {block}/>
{/each}